<template>
    <div ref="section_container" id="section_container" class="container" :class="{'vertical': $store.state.is_horizontal == 0}">
        <div class="row justify-content-center">
            <div class="col-lg-12" v-show="!loading">
                <div class="prev-page">
                    <router-link :to="`/author/page/${prev.book_id}/section/${prev.id}`" class="stretched-link" v-if="prev">
                        <i class="fas fa-arrow-circle-left" v-if="$store.state.is_horizontal"></i>
                        <i class="fas fa-arrow-circle-right" v-else></i>
                        <span v-if="prevChapterChanged" v-html="$filters.ruby(prev.chapter.section_name + ' -')"></span>
                        <span v-html="$filters.ruby(prev.section_name)"></span>
                    </router-link>
                </div>
                <transition mode="out-in">
                    <section-body :loading="loading"
                        :section="section"
                        :prev="prev"
                        ref="sectionBody"
                        @scrollBottom="scrollBottom"
                        @finished="finished"
                        @scrolled="scrolled"
                        v-show="!loading"></section-body>
                </transition>
                <div v-if="isFinished">
                    <div class="next-page" v-if="next">
                        <router-link :to="`/author/page/${next.book_id}/section/${next.id}`" class="stretched-link" v-if="availableNext">
                            <span v-if="nextChapterChanged" v-html="$filters.ruby(next.chapter.section_name + ' -')"></span>
                            <span v-html="$filters.ruby(next.section_name)"></span>
                            <i class="fas fa-arrow-circle-right" v-if="$store.state.is_horizontal"></i>
                            <i class="fas fa-arrow-circle-left" v-else></i>
                        </router-link>
                        <router-link :to="toTop" class="stretched-link" v-else-if="next && next.publish_at">
                            次回
                            {{$filters.dateFormat(next.publish_at)}}
                            更新予定
                        </router-link>
                        <router-link :to="toTop" class="stretched-link" v-else>
                            次回公開をお待ち下さい。
                        </router-link>
                    </div>
                    <div class="next-page" v-else-if="!section.is_finish">
                        <router-link :to="toTop" class="stretched-link">
                            次回の更新をお待ち下さい。
                        </router-link>
                    </div>
                    <div class="next-page" v-else-if="section.is_finish">
                        <router-link :to="toTop" class="stretched-link">
                            了
                        </router-link>
                    </div>
                    <div class="applause" v-if="applause.length">
                        <div class="small clap-label">
                            作者に応援の拍手を送る &#x1f44f;
                        </div>
                        <a href="#" class="btn" :class="{
                            'btn-outline-info': a.can_review,
                            'btn-outline-secondary': !a.can_review,
                        }" v-for="a in applause" :key="a.id" @click.stop.prevent="cheers(a)">
                            <i class="far fa-thumbs-up" v-if="crapped(a.id)"></i>
                            {{a.caption}}
                        </a>
                    </div>
                    <div class="next-page center" v-if="showSeries">
                        <router-link :to="`/author/series/${section.book.series.id}`" class="stretched-link">
                            {{section.book.series.series_name}} へ戻る
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
        <thanks :applause="clicked_applause" :section_id="section.id"></thanks>
    </div>
</template>

<style scoped lang="scss">
#section_container {
    margin-top: 0;
}
.prev-page {
    max-width: 860px;
    margin: 0 auto;
    position: relative;
    padding: 1.5rem 1rem 1rem;
    text-align: left;
    border-radius: .75rem;
    a {
        color: #777;
        &.stretched-link::after {
            z-index: 0;
        }
    }
    &:hover {
        background-color: rgba(255, 255, 255, .2);
    }
}
.next-page {
    max-width: 860px;
    margin: 0 auto;
    position: relative;
    padding: 2rem 2rem 3rem;
    text-align: right;
    font-size: 1rem;
    border-radius: .75rem;
    &.center {
        text-align: center;
    }
    a {
        color: #777;
    }
    a.btn-twitter {
        color: white;
    }
    &:hover {
        background-color: rgba(255, 255, 255, .2);
    }
}
$clap-color: rgba(197, 197, 197, .7);
.applause {
    max-width: 860px;
    margin: 0 auto;
    position: relative;
    padding: 2rem 2rem 3rem;
    text-align: center;
    font-size: 1rem;
    .btn {
        font-weight: bold;
        border-radius: .5rem;
        padding: .5rem 1rem;
        margin: .5rem;
    }
    .clap-label {
        position: relative;
        width: 15rem;
        margin: 0 auto 3rem;
        padding: .5rem;
        background-color: $clap-color;
        border-radius: .3rem;
        &:before {
            content: "";
            position: absolute;
            top: 100%;
            left: 50%;
            margin-left: -15px;
            border: 15px solid transparent;
            border-top: 15px solid $clap-color;
        }
    }
}
.vertical {
    justify-content: center;
    max-width: calc(100vw - 150px);
    overflow: auto;
    -ms-overflow-style: none;   // Edge
    scrollbar-width: none;      // Firefox
    &::-webkit-scrollbar { display:none; }  // Chrome,Safari
    a:hover {
        text-decoration: overline;
    }
    .applause {
        .btn {
            padding: 1rem .5rem;
        }
        .clap-label {
            width: 2.5rem;
            height: 15rem;
            margin: auto 0 auto 2rem;
            &:before {
                content: "";
                position: absolute;
                top: 50%;
                left: -15px;
                margin-top: -15px;
                border: 15px solid transparent;
                border-right: 15px solid $clap-color;
            }
        }
    }
    .prev-page {
        padding: 5rem 1rem 1rem;
    }
    .next-page {
        margin: 0 2rem;
    }
}
.review {
    margin: 1rem;
    text-align: right;
}
@media screen and (max-width: 770px) {
    .col-lg-12 {
        padding: 0;
    }
    .vertical {
        max-width: 100% ;
    }
}
</style>

<script>
import sectionBody from "./section-body"
import thanks from "./modals/thanks";
export default {
    components: {
        sectionBody,
        thanks,
    },
    props: {
        book: {
            default: {}
        }
    },
    data() {
        return {
            section: {},
            prev: {},
            next: {},
            applause: [],
            clicked_applause: {},
            craps: [],  // ユーザーの拍手履歴
            loading: false,
            isFinished: false,  // 全文出力完了
            routeWatcher: null,
        }
    },
    methods: {
        load() {
            $("html,body").animate({scrollTop: 0}, 300);
            this.loading = true;
            axios.get("/author/book/section/get", {params: {id: this.$route.params.id}}).then(res => {
                this.section = res.data.section;
                setTimeout(() => {
                    this.makeHead();
                });
                this.prev = res.data.prev;
                this.next = res.data.next;
                this.applause = res.data.applause;
                this.loading = false;
                if (this.$store.state.is_horizontal) {
                    window.scroll(0, 0);
                } else {
                    setTimeout(() => {
                        let elm = this.$refs.section_container;
                        elm.scrollLeft = 0;
                    })
                }
            }).catch(err => {
                if (err?.response?.status == 404) {
                    alert.err("指定のエピソードは存在しないか、公開が停止されています。");
                    this.$router.push("/");
                } else {
                    alert.err(err);
                }
                this.loading = false;
            });
        },
        makeHead() {
            this.useHead({
                title: this.title + " | " + this.$store.state.bookshelf_name,
                link: [ { rel: "canonical", href: location.origin + location.pathname, id: "canonical" } ],
                meta: [ { name: "description", content: this.description, id: "meta-description" } ]
            });
        },
        loadCraps() {
            axios.get("/author/craps").then(res => {
                this.craps = res.data;
            }).catch(err => { alert.err(err.response) });
        },
        onWheel(ev) {
            this.$refs.section_container.scrollLeft = this.$refs.section_container.scrollLeft - ev.deltaY;
        },
        // スクロール時
        onScroll(ev) {
            if (this.$store.state.output_style > 0) return;
            let elm = document.documentElement;
            let bottom = elm.scrollHeight - elm.clientHeight;
            let scrolled = 0;
            if (this.$store.state.is_horizontal) {
                scrolled = parseInt(window.scrollY / bottom * 100);
            } else {
                const sc = this.$refs.section_container;
                scrolled = parseInt((sc.scrollLeft * -1) / (sc.scrollWidth - sc.clientWidth) * 100);
            }
            this.$emit("scrolled", scrolled);
        },
        // 文字うち時
        scrolled(ev) {
            this.$emit("scrolled", ev);
        },
        cheers(a) {
            axios.post("/author/applause", {
                section_id: this.section.id,
                applause_id: a.id,
            }).then(res => {
                // 拍手成功
                if (a.can_review) {
                    // 拍手モーダル表示
                    this.clicked_applause = a;
                    setTimeout(() => {
                        $("#thanks-modal").modal();
                    });
                } else {
                    alert.msg("拍手ありがとうございます！");
                }
                this.loadCraps();
            }).catch(err => { alert.err(err.response) });
        },
        crapped(id) {
            if (_.find(this.craps, {section_id: this.section.id, applause_id: id})) {
                return true;
            }
            return false;
        },
        scrollBottom() {
            if (this.$store.state.is_horizontal) {
                const elm = document.documentElement;
                const bottom = elm.scrollHeight - elm.clientHeight;
                window.scroll(0, bottom);
            } else {
                let elm = this.$refs.section_container;
                elm.scrollLeft = (elm.scrollWidth - elm.clientWidth) * -1;
            }
        },
        finished(is_finished) {
            this.isFinished = is_finished;
        },
    },
    computed: {
        availableNext() {
            if (this.next && this.next.publish_at) {
                if (moment(this.next.publish_at).isSameOrBefore(moment())) {
                    return true;
                }
            }
            return false;
        },
        prevChapterChanged() {
            return this.section.chapter?.id != this.prev.chapter?.id && this.prev.chapter;
        },
        nextChapterChanged() {
            return this.section.chapter?.id != this.next.chapter?.id && this.next.chapter;
        },
        description() {
            return this.section?.book?.description.replace(/[\r\n]/ug, "").substr(0, 120) || "小説を書くこと、読むことにフォーカスした小説投稿サイトです。作家さんが独自のサブドメインで、ご自身の小説を公開できます。";
        },
        title() {
            if (! this.section?.section_name) {
                return this.section?.book?.title;
            }
            return this.section?.book?.title + " - " + this.section?.section_name;
        },
        toTop() {
            if (this.section?.book?.is_long) {
                return "/author/book/" + this.section.book.id;
            }
            return "/";
        },
        showSeries() {
            if (this.book?.author?.subdomain == this.$store?.state?.subdomain && this.section?.book?.series) {
                return true;
            }
            return false;
        },
    },
    mounted() {
        document.querySelector("#section_container").onwheel = this.onWheel
        document.querySelector("#section_container").onscroll = this.onScroll;;
        document.querySelector("body").onscroll = this.onScroll;;
        this.load();
        this.loadCraps();
        this.routeWatcher = this.$watch('$route', (n, o) => {
            try {
                this.$refs.sectionBody.stop();
                if (this.$route.params.id) {
                    this.load();
                }
            } catch (error) {
            }
        });
    },
    beforeUnmount() {
        this.routeWatcher();
        if (document.querySelector("#section_container")) {
            document.querySelector("#section_container").onwheel = null;
            document.querySelector("#section_container").onscroll = null;
        }
        document.querySelector("body").onscroll = null;
    },
}
</script>